import React, { useState, useEffect, useContext } from "react";
import { useFilter, ContentView, GridSize } from "hooks/filter";
import { Box, Grid,  Select, MenuItem, Dialog, Tooltip, ListItemIcon, ListItemText, FormControl } from "@mui/material";
import { SortField } from '../../../types/qbank/searchSortField';
import { SortDirection } from '../../../types/qbank/searchSortDirection';
import { SearchState } from "../../../hooks/search";
import Transition from "components/Transition";
import FolderMoodBoardPanel from "../folders/FolderMoodBoardPanel";
import { Config } from "types/appConfigV2";
import { TotalHitsContext } from "../../../hooks/TotalHits";



export default function Toolbar(props: {
  config: Config
}) {
  const { contentView, setContentView, searchState, searchDispatch, gridSize, setGridSize } = useFilter();
  const [selectedValue, setSelectedValue] = useState<string>('Id');
  const [isActive, setActive] = useState(false);
  const totalHitsContext = useContext(TotalHitsContext);



  const handleChange = (event: any) => {
    setSelectedValue(event.target.value as string);
    addSort(event.target.value);
  };

  function getSortFieldEnumKeyByValue(value: SortField): keyof typeof SortField {
    return (Object.keys(SortField) as Array<keyof typeof SortField>).find(
      key => SortField[key] === value
    )!;
  }

  const getActiveSortOption = (searchState: SearchState) => {
    const sortFields: any = searchState.search.sortFields;
    return (
      sortFields !== undefined ? getSortFieldEnumKeyByValue(sortFields[0].sortField) : ''
    );
  };

  useEffect(() => {
    const sortField = getActiveSortOption(searchState);
    if (sortField !== '') {
      setSelectedValue(sortField);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState.search.sortFields]);

  function addSort(field: string) {

    searchDispatch({
      type: "ADD_SORT",
      payload: {
        sortField: SortField[field as keyof typeof SortField],
        sortDirection: SortDirection.DESC
      },
    });

  }
  function toggleFolderPanel() {
    setActive(!isActive);
  }

  function showFolderIcon() {
    if (props.config.folders || props.config.moodboard) {
      return true;
    }
    return false;
  }

  function getToolTipMessage() {
    if (props.config.folders && props.config.moodboard)
      return "Folders and Moodboards";

    if (props.config.folders)
      return "Folders";

    if (props.config.moodboard)
      return "Moodboards";

    return "";
  }
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
          {showFolderIcon() && (
            <Tooltip title={getToolTipMessage()}>
            <Grid item>
              <div onClick={toggleFolderPanel}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-square-mouse-pointer-icon lucide-square-mouse-pointer"><path d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" /><path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" /></svg>
                <span className="text-normal p-left-6">{totalHitsContext?.totalHits} assets</span>
              </div>
            </Grid>
            </Tooltip>
          )}
          {(!showFolderIcon() &&
            <Grid item>
              <span className="text-normal .p-left-6">{totalHitsContext?.totalHits} assets</span>
            </Grid>
          )}
        <Grid item>
            <Grid container justifyContent="flex-end" spacing={2}>
              <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Sort by">
              <Select
              labelId="dropdown-label"
                variant="standard"
                disableUnderline
                sx={{
                  border: 'none',
                  backgroundColor: 'transparent',
                  '&::before, &::after': {
                    display: 'none',
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    display: 'none',
                  },
                }}
              value={selectedValue}
                onChange={handleChange} >
                <MenuItem sx={{ fontSize: '14px', fontWeight: 400 }} value="Id">Latest</MenuItem>
                <MenuItem sx={{ fontSize: '14px', fontWeight: 400 }} value="Relevance">Relevance</MenuItem>
            </Select>
              </Tooltip>
              </Grid>

              {(contentView === "grid" || contentView === "masonry") && (
                <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title={`Current Thumbnail Size: ${gridSize === 'small' ? 'Small' : gridSize === 'medium' ? 'Medium' : 'Large'}`} placement="top">
                    <Select
                      labelId="grid-size-label"
                      variant="standard"
                      disableUnderline
                      size="small"
                      value={gridSize}
                      onChange={(e) => {
                        console.log('Setting thumbnail size to:', e.target.value);
                        setGridSize(e.target.value as GridSize);
                      }}
                      sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        minWidth: '40px',
                        '&::before, &::after': {
                          display: 'none',
                        },
                        '&:hover:not(.Mui-disabled):before': {
                          display: 'none',
                        },
                        '& .MuiSelect-select': {
                          fontSize: '14px',
                          fontWeight: 400,
                          padding: '4px 20px 4px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minWidth: 40,
                        },
                      }}
                      renderValue={(value) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {value === 'small' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-minimize2-icon lucide-minimize-2"><path d="m14 10 7-7" /><path d="M20 10h-6V4" /><path d="m3 21 7-7" /><path d="M4 14h6v6" /></svg>}
                          {value === 'medium' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-square-icon lucide-square"><rect width="18" height="18" x="3" y="3" rx="2" /></svg>}
                          {value === 'large' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-maximize2-icon lucide-maximize-2"><path d="M15 3h6v6" /><path d="m21 3-7 7" /><path d="m3 21 7-7" /><path d="M9 21H3v-6" /></svg>}
                        </Box>
                      )}
                    >
                      <MenuItem value="small">
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-minimize2-icon lucide-minimize-2"><path d="m14 10 7-7" /><path d="M20 10h-6V4" /><path d="m3 21 7-7" /><path d="M4 14h6v6" /></svg>
                        </ListItemIcon>
                        <ListItemText primary="Small" />
                      </MenuItem>
                      <MenuItem value="medium">
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-square-icon lucide-square"><rect width="18" height="18" x="3" y="3" rx="2" /></svg>
                        </ListItemIcon>
                        <ListItemText primary="Medium" />
                      </MenuItem>
                      <MenuItem value="large">
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-maximize2-icon lucide-maximize-2"><path d="M15 3h6v6" /><path d="m21 3-7 7" /><path d="m3 21 7-7" /><path d="M9 21H3v-6" /></svg>
                        </ListItemIcon>
                        <ListItemText primary="Large" />
                      </MenuItem>
                    </Select>
                  </Tooltip>
                </Grid>
              )}
              <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title={`Current view: ${contentView === 'grid' ? 'Grid' : contentView === 'list' ? 'List' : 'Masonry'}`} placement="top">
                  <FormControl size="small" sx={{ minWidth: 40 }}>
                    <Select
                      value={contentView}
                      onChange={(e) => setContentView(e.target.value as ContentView)}
                      variant="standard"
                      disableUnderline
                      sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        minWidth: 40,
                        '&::before, &::after': {
                          display: 'none',
                        },
                        '&:hover:not(.Mui-disabled):before': {
                          display: 'none',
                        },
                        '& .MuiSelect-select': {
                          fontSize: '14px',
                          fontWeight: 400,
                          padding: '4px 20px 4px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          minWidth: 40,
                        },
                      }}
                      renderValue={(value) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {value === 'grid' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-grid2x2-icon lucide-grid-2x2"><path d="M12 3v18" /><path d="M3 12h18" /><rect x="3" y="3" width="18" height="18" rx="2" /></svg>}
                          {value === 'list' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-list-icon lucide-list"><path d="M3 5h.01" /><path d="M3 12h.01" /><path d="M3 19h.01" /><path d="M8 5h13" /><path d="M8 12h13" /><path d="M8 19h13" /></svg>}
                          {value === 'masonry' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-layout-dashboard-icon lucide-layout-dashboard"><rect width="7" height="9" x="3" y="3" rx="1" /><rect width="7" height="5" x="14" y="3" rx="1" /><rect width="7" height="9" x="14" y="12" rx="1" /><rect width="7" height="5" x="3" y="16" rx="1" /></svg>}
                        </Box>
                      )}
                    >
                      <MenuItem value="grid">
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-grid2x2-icon lucide-grid-2x2"><path d="M12 3v18" /><path d="M3 12h18" /><rect x="3" y="3" width="18" height="18" rx="2" /></svg>
                        </ListItemIcon>
                        <ListItemText primary="Grid" />
                      </MenuItem>
                      <MenuItem value="list">
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-list-icon lucide-list"><path d="M3 5h.01" /><path d="M3 12h.01" /><path d="M3 19h.01" /><path d="M8 5h13" /><path d="M8 12h13" /><path d="M8 19h13" /></svg>
                        </ListItemIcon>
                        <ListItemText primary="List" />
                      </MenuItem>
                      <MenuItem value="masonry">
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-layout-dashboard-icon lucide-layout-dashboard"><rect width="7" height="9" x="3" y="3" rx="1" /><rect width="7" height="5" x="14" y="3" rx="1" /><rect width="7" height="9" x="14" y="12" rx="1" /><rect width="7" height="5" x="3" y="16" rx="1" /></svg>
                        </ListItemIcon>
                        <ListItemText primary="Masonry" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
              </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
      {showFolderIcon() && (
        <Dialog
          fullScreen
          open={isActive}
          onClose={() => setActive(false)}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              overflow: 'hidden',
            },
          }}
        >
          <FolderMoodBoardPanel
            closePanel={() => setActive(false)}
            showFolders={props.config.folders}
            showMoodboards={props.config.moodboard}
          />
        </Dialog>
      )}
    </>
  );
}
